// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YYil","buttons":"Footer_buttons__3axlZ"};